import styled from 'styled-components';

import colors from '../../../../../../../../styles/colors';

export const LoadingContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  p {
    margin: 0;
    margin-right: 10px;
    color: ${colors.$greyscale_light_grey_9};
  }

  div {
    display: flex;
  }
`;
